var _style, _path, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 26",
    style: {
      enableBackground: "new 0 0 35 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30,12.2L18.2,0.5c-0.4-0.4-1-0.4-1.4,0L7.7,9.6c0,0,0,0,0,0L5,12.2c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0 l0.9-0.9v12.1c0,0.5,0.4,1,1,1h6.5c0.5,0,1-0.4,1-1v-6.4c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7v6.4c0,0.5,0.4,1,1,1h6.2 c0.5,0,1-0.4,1-1V12.5l1.2,1.2c0.2,0.2,0.4,0.3,0.7,0.3s0.5-0.1,0.7-0.3C30.3,13.2,30.3,12.6,30,12.2z M25.4,23.8h-4.2v-5.4 c0-2-1.7-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7v5.4H9.4V11.3h16V23.8z M10.8,9.3l6.7-6.7l6.7,6.7H10.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.8,30.8c1.6,0,3,1.3,3,3s-1.3,3-3,3c-1.6,0-3-1.3-3-3S84.2,30.8,85.8,30.8 M85.8,29.3c-2.5,0-4.5,2-4.5,4.5 c0,2.5,2,4.5,4.5,4.5c2.5,0,4.5-2,4.5-4.5C90.3,31.3,88.3,29.3,85.8,29.3L85.8,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5,47.1H92v-2.5c0-2.1-1.7-3.8-3.8-3.8h-4.7c-2.1,0-3.8,1.7-3.8,3.8v2.5h-1.5v-2.5c0-2.9,2.4-5.3,5.3-5.3 h4.7c2.9,0,5.3,2.4,5.3,5.3V47.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51,31.6v14H38.9v-14H51 M52.5,30.1H37.4v17h15.1V30.1L52.5,30.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.4,
    y: 29,
    width: 1.5,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.9,
    y: 29,
    width: 1.5,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.4,
    y: 29,
    width: 1.5,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 29,
    width: 1.5,
    height: 3.3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.2,41.7 41,38.2 42.2,37.2 44.2,39.5 48.1,35.2 49.2,36.2  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.2,35.5c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.2 c0.3-0.3,0.8-0.3,1.1,0c0.1,0.1,0.1,0.2,0.2,0.2c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.1,0.1-0.2,0.2 C3.4,35.5,3.3,35.5,3.2,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4,38.7c0-0.4,0.3-0.8,0.8-0.8l0,0c0.4,0,0.8,0.3,0.8,0.8l0,0c0,0.4-0.3,0.8-0.8,0.8l0,0 C2.8,39.4,2.4,39.1,2.4,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2,43.3c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3 c0-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.2c0.2-0.1,0.4-0.1,0.6,0c0.1,0,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.2,0.2C3.6,43.2,3.4,43.3,3.2,43.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.8,32.4v12.5h-23v-3.8c0.8-0.5,1.4-1.4,1.4-2.5c0-1.1-0.6-2-1.4-2.5v-3.8H19.8 M21.3,30.9h-26v6.3 c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4v6.3h26V30.9L21.3,30.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M128,40.1c-0.4,0-0.8-0.1-1.1-0.4c-0.1-0.1-0.2-0.3-0.3-0.5c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.4,0.2-0.8,0.4-1.1 c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2-0.1,0.3-0.1c0.5-0.1,1,0.1,1.4,0.4c0.3,0.3,0.4,0.7,0.4,1.1 c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.2,0.3-0.3,0.5C128.8,40,128.4,40.1,128,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6,38.6c0-0.8,0.7-1.5,1.5-1.5l0,0c0.8,0,1.5,0.7,1.5,1.5l0,0c0,0.8-0.7,1.5-1.5,1.5l0,0 C122.2,40.1,121.6,39.4,121.6,38.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.2,40.1c-0.4,0-0.8-0.1-1.1-0.4c-0.3-0.3-0.4-0.7-0.4-1.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0.1-0.3 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.2-0.2c0.6-0.6,1.6-0.6,2.1,0c0.1,0.1,0.1,0.2,0.2,0.2c0,0.1,0.1,0.2,0.1,0.3 c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.4-0.1,0.8-0.4,1.1c-0.1,0.1-0.3,0.2-0.5,0.3C118.6,40.1,118.4,40.1,118.2,40.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.71e52990d28bb4144338054006c86076.svg";
export { ForwardRef as ReactComponent };